/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_New_Marker_TitleInputs */



/**
* | output |
* | --- |
* | "New Marker" |
*
* @param {Markers_New_Marker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_new_marker_title = /** @type {((inputs?: Markers_New_Marker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_New_Marker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Marker")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいマーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo marcador")
	return /** @type {LocalizedString} */ ("New Marker")
});